export default __webpack_public_path__ + "static/media/cannon_1k.e563838c.hdr";